export { default } from "./getNationalUrlByDevice";
